import React, { ChangeEvent } from "react";

import { DateTime } from "luxon";

import Calendar2 from "../Calendar2";
import DelayInput from "../DelayInput";

import { V2 } from "../../Api";
import withTitle from "../withTitle";

interface IScheduleViewState {
    events: any;
    isLoading: boolean | string;

    month: string;

    displayAfter: DateTime;
    displayBefore: DateTime;

    [name: string]: any;
}

class ScheduleView extends React.Component<{}, IScheduleViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        const today = DateTime.local();

        const state: IScheduleViewState = {
            events: {},
            isLoading: false,

            month: today.startOf("month").toFormat("yyyy-MM"),

            displayBefore: today.endOf("month"),
            displayAfter: today.startOf("month"),
        };

        this.state = state;

        this.handleElementChange = this.handleElementChange.bind(this);
        this.displayRangeChanged = this.displayRangeChanged.bind(this);
    }

    public render() {
        return (
            <div className="viewer-root viewer-full full-height">
                <div className="filter-control-box">
                    <DelayInput type="month" className="fill-space" timeout={500} value={this.state.month} name="month" onChangeDelayed={this.handleElementChange} />
                </div>

                <div className="spinner-overlay-root full-height">
                    <Calendar2 className="full-height" displayMonth={this.state.month} highlightDate={new Date()} showDetailsOnClick={true} events={this.state.events} onDisplayRangeChanged={this.displayRangeChanged} />
                    {
                        this.state.isLoading ? (
                            <div className="spinner-overlay">
                                {
                                    (typeof this.state.isLoading === "string") ?
                                        <span className="error-text-big">{this.state.isLoading}</span> :
                                        <div className="lds-dual-ring-big" />
                                }
                            </div>
                        ) : ""
                    }
                </div>
            </div>
        );
    }

    private async loadData() {
        try {
            this.setState({
                events: {},
                isLoading: true,
            });

            const beginDate = this.state.displayAfter;
            const endDate = this.state.displayBefore.plus({ millisecond: 1 });

            const parameters = [
                `after=${encodeURIComponent(beginDate.toISO())}`,
                `before=${encodeURIComponent(endDate.toISO())}`,
            ];

            const data = await V2.get<any[]>(`schedule?${parameters.join("&")}`);

            const monthBase = DateTime.fromISO(this.state.month);
            const events: { [date: number]: Array<{ title: string, type?: string, length?: number, item?: any }>; } = {};
            for (const item of data) {
                const dayDiff = DateTime.fromISO(item.date).diff(monthBase, "days").days + 1;
                const runLength = Math.max(Math.round(item.length || 0), 1);

                if (!item.location) {
                    item.location = { id: "0", name: "On Vacation", color: "white" };
                }

                if (!events[dayDiff])
                    events[dayDiff] = [];

                events[dayDiff].push({
                    title: item.location.shortName || item.location.name,
                    type: item.location.color || "",
                    length: runLength,
                    item
                });
            }

            this.setState({
                events,
                isLoading: false
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || e || "Unable to load schedule"
            });
        }
    }

    private handleElementChange(e: ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLInputElement>) {
        const value = e.currentTarget.value;
        const name = e.currentTarget.name;

        if (name === "month" && !value) {
            return;
        }

        this.setState({
            [name]: value
        }, () => {
            // this.saveSearchState();
            if (name !== "month") {
                this.loadData();
            }
        });
    }

    private displayRangeChanged(minDate: string, maxDate: string) {
        this.setState({
            displayBefore: DateTime.fromISO(maxDate).toLocal(),
            displayAfter: DateTime.fromISO(minDate).toLocal()
        }, () => this.loadData());
    }
}

export default withTitle("Your Schedule", ScheduleView);